/** API route map: URLS.Controller.EmployeeFormRequest */
export const EmployeeFormRequest = {
      Name: 'EmployeeFormRequest/',
      GetAllEmployeeFormRequest: 'get-all-employee-form-requests',
      addEmployeeFormRequest: 'add-employee-form-request',
      checkEmployeeFormRequestValidity: 'check-employee-form-request-validity',
      GetEmployeeAccessDocument: 'get-emp-document-access',
};
